/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@material-ui/core";
import moment from "moment-jalaali";
import { DatePicker } from "@material-ui/pickers";
import StyledButton from "../../../../../UIcomponent/Button";
import Container from "./Container";

const initDate = {
  from: new Date(),
  to: new Date(),
};

function Experience(props) {
  const { experiences = [], moveData } = props;
  const titleRef = useRef();
  const companyRef = useRef();
  const descriptionRef = useRef();
  const countryRef = useRef();
  const cityRef = useRef();

  const [state, setState] = useState({
    data: experiences || [],
    modal: { isOpen: false, editMode: false, selectedIndex: null },
  });

  const [newDate, setNewDate] = useState(initDate);

  const closeModal = () => {
    setState({
      ...state,
      modal: {
        editMode: false,
        isOpen: false,
        selectedIndex: null,
      },
    });
  };

  const openModalEditMode = (index) => {
    setNewDate({
      from: state.data[index].from,
      to: state.data[index].to,
    });

    setState({
      ...state,
      modal: {
        editMode: true,
        selectedIndex: index,
        isOpen: true,
      },
    });
  };

  const openModal = (index) => {
    setState({
      ...state,
      modal: {
        ...state.modal,
        isOpen: true,
      },
    });
  };

  const removeItem = () => {
    setNewDate(initDate);
    setState({
      ...state,
      data: state.data.filter((item, i) => i !== state.modal.selectedIndex),
      modal: {
        editMode: false,
        isOpen: false,
        selectedIndex: null,
      },
    });
    moveData(state.data.filter((item, i) => i !== state.modal.selectedIndex));
  };

  const done = () => {
    let newData = state.data;
    if (state.modal.editMode) {
      newData[state.modal.selectedIndex].title = titleRef.current.value;
      newData[state.modal.selectedIndex].company = companyRef.current.value;
      newData[state.modal.selectedIndex].description =
        descriptionRef.current.value;
      newData[state.modal.selectedIndex].country = countryRef.current.value;
      newData[state.modal.selectedIndex].city = cityRef.current.value;
      newData[state.modal.selectedIndex].from = newDate.from;
      newData[state.modal.selectedIndex].to = newDate.to;
      newData[state.modal.selectedIndex].verified = false;

      setState({
        data: newData,
        modal: {
          editMode: false,
          isOpen: false,
          selectedIndex: null,
        },
      });
    } else {
      newData.push({
        title: titleRef.current.value,
        company: companyRef.current.value,
        description: descriptionRef.current.value,
        country: countryRef.current.value,
        city: cityRef.current.value,
        from: newDate.from,
        to: newDate.to,
        verified: false,
      });

      setNewDate(initDate);
      setState({
        data: newData,
        modal: {
          editMode: false,
          isOpen: false,
          selectedIndex: null,
        },
      });
    }
    setNewDate(initDate);
    moveData(state.data);
  };

  const set = (date, key) => {
    setNewDate({
      ...newDate,
      [key]: date,
    });
  };

  return (
    <>
      <Container>
        <div className="sub-title-bar">
          <h4>سوابق کاری</h4>
        </div>
        <div className="list">
          {state.data.map((item, index) => {
            return (
              <div
                onClick={() => openModalEditMode(index)}
                className={`${
                  item.verified ? "verified" : "not-verified"
                } item`}
              >
                <div className="title">{item.title}</div>
                <div className="title">{item.company}</div>
                <div className="title">{item.description}</div>
                <div className="title">{item.country}</div>
                <div className="title">{item.city}</div>
                <div className="title">
                  {moment(item.from).format("jYYYY/jM/jD")} -
                  {moment(item.to).format("jYYYY/jM/jD")}
                </div>
                <div className="verify-text">
                  ({item.verified ? "تایید شده" : "تایید نشده"})
                </div>
              </div>
            );
          })}
        </div>
        <br />
        <StyledButton onClick={openModal} primary>
          اضافه کردن +
        </StyledButton>
      </Container>
      <Dialog
        maxWidth={"xs"}
        fullWidth="xs"
        open={state.modal.isOpen}
        onClose={closeModal}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {state.modal.editMode ? "ویرایش سایقه" : "اضافه کردن سابقه"}
        </DialogTitle>
        <DialogContent>
          <TextField
            style={{ marginBottom: 15 }}
            fullWidth="xs"
            defaultValue={
              state.modal.editMode
                ? state.data[state.modal.selectedIndex].company
                : ""
            }
            inputRef={companyRef}
            id="outlined-basic"
            label="شرکت / آموزشگاه"
            variant="outlined"
          />
          <br />
          <TextField
            style={{ marginBottom: 15 }}
            fullWidth="xs"
            defaultValue={
              state.modal.editMode
                ? state.data[state.modal.selectedIndex].title
                : ""
            }
            inputRef={titleRef}
            id="outlined-basic"
            label="سمت"
            variant="outlined"
          />
          <br />
          <TextField
            style={{ marginBottom: 15 }}
            fullWidth="xs"
            defaultValue={
              state.modal.editMode
                ? state.data[state.modal.selectedIndex].description
                : ""
            }
            inputRef={descriptionRef}
            id="outlined-basic"
            label="توضیحات"
            variant="outlined"
          />
          <br />
          <TextField
            style={{ marginBottom: 15 }}
            fullWidth="xs"
            defaultValue={
              state.modal.editMode
                ? state.data[state.modal.selectedIndex].city
                : ""
            }
            inputRef={countryRef}
            id="outlined-basic"
            label="کشور"
            variant="outlined"
          />
          <br />
          <TextField
            style={{ marginBottom: 15 }}
            fullWidth="xs"
            defaultValue={
              state.modal.editMode
                ? state.data[state.modal.selectedIndex].country
                : ""
            }
            inputRef={cityRef}
            id="outlined-basic"
            label="شهر"
            variant="outlined"
          />
          <DatePicker
            autoOk
            variant="inline"
            inputVariant="outlined"
            label="تاریخ شروع"
            fullWidth
            format="yyyy/MM/dd"
            labelFunc={(date) => (date ? date.format("jYYYY/jMM/jDD") : "")}
            value={newDate.from}
            onChange={(e) => set(e, "from")}
          />
          <br />
          <br />
          <DatePicker
            autoOk
            inputVariant="outlined"
            label="تاریخ پایان"
            variant="inline"
            fullWidth
            format="yyyy/MM/dd"
            labelFunc={(date) => (date ? date.format("jYYYY/jMM/jDD") : "")}
            value={newDate.to}
            onChange={(e) => set(e, "to")}
          />
        </DialogContent>
        <DialogActions>
          <Button style={{ marginLeft: "auto" }} onClick={closeModal}>
            لغو
          </Button>
          <div>
            <Button
              onClick={removeItem}
              style={{ margin: 5 }}
              variant="contained"
            >
              حذف
            </Button>
            <Button onClick={done} variant="contained" color="primary">
              ثبت
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default Experience;
